export const SET_SIDE_PANEL_VALUE = "SET_SIDE_PANEL_VALUE";
export const SET_DEVICE_TYPE = "SET_DEVICE_TYPE";
export const SET_PAGE_LOADING = "SET_PAGE_LOADING";
export const SET_SUBSCRIPTION_STATUS = "SET_SUBSCRIPTION_STATUS";